export default __webpack_public_path__ + "58c2389485ed98fe53fa8d2af802e108.svg";